import React, { useMemo } from 'react';

import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import useMediaQuery from 'hooks/use-media-query';

import { IFilter } from './types';

const Container = styled(ClickableContainer)`
  grid-area: tags;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  min-height: 0;
  padding: 1rem 0.5rem 0;

  ${Styles.desktop`
    padding: 0.5rem 1rem 0;
    min-height: 2.5rem;
  `}
`;

const Tag = styled.button`
  padding: 2px 10px;
  margin-right: 5px;
  margin-bottom: 5px;

  cursor: pointer;
  font: inherit;
  font-size: 0.7rem;
  font-weight: ${Styles.fontWeight.heavy};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  background: none;
  background-color: ${Styles.color.grey.three};
  color: ${Styles.color.white};
  text-transform: uppercase;
  border: none;
  border-radius: 4px;

  ${Styles.desktop`
    font-size: 0.8rem;
  `}
`;

const messages = defineMessages({
  remainingTags: {
    id: 'filters',
    defaultMessage: '{remainingTagsCount, plural, one {filter} other {filters}}',
    description: 'Number of filters',
  },
});

interface ITags {
  activeModalFilters: IFilter[];
  openFilterModal: () => void;
}

export const Tags: React.FC<ITags> = ({ activeModalFilters, openFilterModal }) => {
  const isMobile = useMediaQuery('mobile');
  const { formatMessage } = useIntl();

  const filterTags = useMemo(() => {
    return activeModalFilters.map(filter => filter.description.locale);
  }, [activeModalFilters]);

  const tagsToShow = isMobile ? filterTags.slice(0, 1) : filterTags.slice(0, 2);
  const remainingTagsCount = filterTags.length - tagsToShow.length;

  return (
    <Container data-testid="tags-container">
      {tagsToShow.map(tag => (
        <Tag key={tag} onClick={openFilterModal}>
          {tag}
        </Tag>
      ))}
      {remainingTagsCount > 0 && (
        <Tag onClick={openFilterModal}>
          {formatMessage(messages.remainingTags, { remainingTagsCount })}
        </Tag>
      )}
    </Container>
  );
};
